export default __webpack_public_path__ + "static/media/ellipse13534367-x809.5fcda435.svg";